import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data";
import Reveal from "@/components/landing/Reveal";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="bg-cloud py-24 md:py-32">
    <div className="max-w-[1440px] mx-auto px-5 md:px-12">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto">
          <span className="font-display uppercase tracking-[0.2em] text-gold text-sm font-semibold">
            06 — Social Proof
          </span>
          <h2 className="mt-4 font-display font-bold uppercase text-navy text-4xl md:text-6xl leading-[0.9] tracking-tight">
            Homeowners love the results
          </h2>
        </div>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure
              className="relative bg-white rounded-3xl p-8 md:p-10 border border-navy/5 shadow-[0_10px_40px_rgba(15,45,82,0.06)] h-full"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={44} className="text-gold/25 absolute top-7 right-7" />
              <div className="flex gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={20} className="text-gold fill-gold" />
                ))}
              </div>
              <blockquote className="font-display text-navy text-2xl md:text-[1.7rem] leading-snug tracking-tight">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-4">
                <span className="w-12 h-12 rounded-full bg-navy flex items-center justify-center font-display font-bold text-gold text-lg">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="font-body font-bold text-navy">{t.name}</div>
                  <div className="font-body text-navy/55 text-sm">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
